import React from "react";
import _ from "lodash";
import { ReactComponent as CrossSvg } from "../../../assets/images/opt/cross.svg";

const DeleteModal = ({
  name,
  event,
  onClose,
  onDelete,
  remove_modal_params
}) => {
  const event_text = _.get(
    remove_modal_params,
    "event",
    "Are you sure you want to remove this event?"
  );
  const participant = _.get(
    remove_modal_params,
    "participant",
    "Are you sure you want to remove this participant from the Team Building Event?"
  );
  const back_btn = _.get(remove_modal_params, "back_btn", "Back");
  const remove_btn = _.get(remove_modal_params, "remove_btn", "Yes, Remove");

  return (
    <div onClick={onClose} className="event-delete-modal">
      <div onClick={(e) => e.stopPropagation()} className="modal-inner">
        <div className="top-div">
          <h2 className="modal-text">{event ? event_text : participant}</h2>
          <CrossSvg onClick={onClose} className="modal-cross" />
        </div>
        <h2 className="modal-text name">{name}</h2>
        <div className="button-div">
          <div onClick={onClose} className="modal-button back">
            {back_btn}
          </div>
          <div onClick={onDelete} className="modal-button remove">
            {remove_btn}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
